import { observer } from "mobx-react-lite";
import { useTranslation } from "../i18n/useTranslation.js";
import { PRODUCT_CONFIG } from "../config/productConfig.js";
import IntroOverlay from "./IntroOverlay.js";

const WelcomeHero = observer(() => {
  const { t } = useTranslation();
  return (
    <section className="landing-opening">
      <div className="landing-opening-art" role="img" aria-label={t("landing.home.artAlt")} />
      <IntroOverlay />
      <div className="landing-opening-shade" />
      <div className="landing-opening-content">
        <p className="landing-status"><span aria-hidden="true" />{t("landing.home.status")}</p>
        <p className="landing-eyebrow">{t("landing.home.eyebrow")}</p>
        <h1>{t("landing.home.title")}</h1>
        <p className="landing-opening-copy">{t("landing.home.lead")}</p>
        <div className="landing-actions">
          <a className="landing-primary-action" href={PRODUCT_CONFIG.loginPath}>{t("landing.home.enter")}</a>
        </div>
      </div>
      <div className="landing-opening-caption">
        <span>{t("landing.home.captionLabel")}</span><p>{t("landing.home.caption")}</p>
      </div>
    </section>
  );
});

export default WelcomeHero;
